import dateFilter from "./dateFilter.component";

const dateFilterModule = angular
  .module("app.components.dateFilter", [])
  .component("dateFilter", dateFilter);

export default dateFilterModule;



// WEBPACK FOOTER //
// ./src/components/dateFilter/dateFilter.module.js